import { createSelector } from 'reselect'
import isValidLoyaltyRegion from 'api/lib/isValidLoyaltyRegion'

/**
 * The region to auto-enrol a signed-in non-member in: their account country if it's a loyalty
 * region, otherwise the site region. Undefined when neither is, so the customer isn't enrolled.
 */
const getLoyaltyAutoEnrolmentRegion = createSelector(
  (state: App.State) => state.auth.account.countryCode,
  (state: App.State) => state.geo.currentRegionCode,
  (countryCode, currentRegion): string | undefined => {
    const accountRegion = countryCode?.toUpperCase()
    if (isValidLoyaltyRegion(accountRegion)) return accountRegion
    if (isValidLoyaltyRegion(currentRegion)) return currentRegion
  },
)

export default getLoyaltyAutoEnrolmentRegion
